import { useContext } from 'react';
import { Card, CardContent, Typography, Divider, Box } from '@mui/material';
import { useB3Lang } from '@b3/lang';
import { OrderDetailsContext } from '../context/OrderDetailsContext';

export default function OrderExtraStatuses() {
  const b3Lang = useB3Lang();
  const {
    state: { extraStatuses },
  } = useContext(OrderDetailsContext);

  if (!extraStatuses || Object.keys(extraStatuses).length === 0) {
    return null;
  }

  return (
    <Card
      sx={{
        borderRadius: 1,
        boxShadow: 3,
        backgroundColor: '#f9f9f9',
        border: '1px solid #ddd',
      }}
    >
      <CardContent>
        <Typography 
          variant="h5" 
          sx={{ 
            fontWeight: 600, 
            marginBottom: 2, 
            color: '#333' 
          }}
        >
          {b3Lang('orderDetail.extraStatuses.title')}
        </Typography>

        <Divider sx={{ marginBottom: 2 }} />

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          {Object.entries(extraStatuses).map(([key, value], index) => (
            <Box 
              key={key} 
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                backgroundColor: index % 2 === 0 ? '#fff' : '#f1f1f1',
                padding: '8px 12px',
                borderRadius: 2,
              }}
            >
              <Typography variant="body1" sx={{ fontWeight: 500, color: '#555' }}>
                {b3Lang(`orderStatus.${key}`)}
              </Typography>
              <Typography 
                variant="body2" 
                sx={{ 
                  fontWeight: 600, 
                  color: '#0288D1' 
                }}
              >
                {value}
              </Typography>
            </Box>
          ))}
        </Box>
      </CardContent>
    </Card>
  );
}
